// src/api/vehicleApi.ts
import axios from 'axios';
import { Asset } from '../state/types';
import { fetchAuthSession } from 'aws-amplify/auth';

// src/api/vehicleApi.ts
const isYyyyMmDd = (v: unknown): v is string =>
  typeof v === "string" && /^\d{4}-\d{2}-\d{2}$/.test(v);

/**
 * Converts YYYY-MM-DD to epoch seconds using *local* time.
 * - start_date -> local 00:00:00
 * - end_date   -> local 23:59:59
 */
const normalizeAssetDateFilters = (body: Record<string, any>) => {
  const next = { ...body };

  if (isYyyyMmDd(next.start_date)) {
    const d = new Date(`${next.start_date}T00:00:00`);
    next.start_date = String(Math.floor(d.getTime() / 1000));
  }

  if (isYyyyMmDd(next.end_date)) {
    const d = new Date(`${next.end_date}T00:00:00`);
    d.setDate(d.getDate() + 1);
    next.end_date = String(Math.floor(d.getTime() / 1000) - 1);
  }

  // Optional safety: if timestamps come in as numbers, force them to strings
  if (typeof next.start_date === "number") next.start_date = String(next.start_date);
  if (typeof next.end_date === "number") next.end_date = String(next.end_date);

  return next;
};

export const getVehiclesFromDb = async (
  body: Record<string, any>
): Promise<{ vehicles: Asset[]; total: number }> => {
  try {
    const normalizedBody = normalizeAssetDateFilters(body);
    console.log(body, normalizedBody)

    if (normalizedBody.clientId === "undefined") return { vehicles: [], total: 0 };

    const awsTokens = await fetchAuthSession()
    const authHeader = 'bwdevenv' //awsTokens.tokens?.idToken?.toString()
    const url = `${process.env.REACT_APP_UMS_API_BASE_URL}/asset/client`;
    const headers = {
      Authorization: authHeader,
    };

    const response = await axios.post<{ vehicles: Asset[]; total_vehicles: number }>(url, normalizedBody, { headers });

    const vehicles = response.data.vehicles.map((vehicle: any) => {
      const primaryImagePattern = /-?0?1\.jpg$/;
      const bgrImage = vehicle.imageBgrExterior?.find(
        (img: any) => img.imageOriginalName && primaryImagePattern.test(img.imageOriginalName)
      )?.imageUrlCf;

      const cropImage = vehicle.imageCropExterior?.find(
        (img: any) => img.imageOriginalName && primaryImagePattern.test(img.imageOriginalName)
      )?.imageUrlCf;

      const regularImage = vehicle.imageExterior?.[0]?.imageUrlCf;
      const cfUrl = bgrImage || cropImage || regularImage || '';
      const thumbnailUrl = cfUrl
        ? cfUrl.replace(/(\.[^./\?]+)$/, '_thumbnail$1')
        : '';
      const assetId = vehicle.pk.split('#')[1];
      const rawClientId = vehicle.clientIdentifier;
      const cleanedClientId = /U\d{2}$/.test(rawClientId)
        ? rawClientId.slice(0, -3)
        : rawClientId;

      return {
        ...vehicle,
        vin: vehicle.assetIdentifier,
        clientId: cleanedClientId,
        created_at: vehicle.sk,
        thumbnail: thumbnailUrl,
        config: vehicle.configurationName,
        assetId,
      };
    });

    return {
      vehicles,
      total: response.data.total_vehicles,
    };
  } catch (error) {
    console.error('Error fetching vehicles:', error);
    return { vehicles: [], total: 0 };
  }
};

